module.exports = __webpack_public_path__ + "img/cyber.e1a80852.svg";